export const RecordPaymentValidate = (recordArray) => {
    const newErrors = {}; 
    recordArray.forEach((record, index) => {
       
        if (!record.amt) {
          newErrors[`record.${index}.amt`] = "Payment Amount is Required!";
        }
        if (record.crg && record.crg > record?.amt) {
          newErrors[`record.${index}.crg`] = "Bank Charge Amount cannot exceed the Received Amount!!";
        }
        if (!record.dt) {
          newErrors[`record.${index}.dt`] = "Payment Date is Required!";
        } 
        if (!record.mod) {
          newErrors[`record.${index}.mod`] = "Payment Mode is Required!";
        }   
        });
      return newErrors;
};

export const sumOfInvoiceTdsBaseAmount = (tdsRecords)=>{
  if (tdsRecords) {
    const array = tdsRecords;
    if (array.length > 0) {
      const sum = array.reduce((acc, current) => {
        if (current?.bsAmt && current?.bsAmt !== "") {
          return acc + parseFloat(current.bsAmt);
        } else {
          return acc;
        }
      }, 0);
      return sum; 
    }
    else return 0;
  }
}
export const sumOfInvoiceTdsAmount = (tdsRecords)=>{
  if (tdsRecords) {
    const array = tdsRecords;
    if (array.length > 0) {
      const sum = array.reduce((acc, current) => {
        if (current?.tdsAmt && current?.tdsAmt !== "") {
          return acc + parseFloat(current.tdsAmt);
        } else {
          return acc;
        }
      }, 0);
      return sum; 
    }
    else return 0;
  }
}

export const sumOfRefundAmount = (refundRecords) => {
  const sum = refundRecords.reduce((acc, current) => {
    if (current?.amt && current?.amt !== "") {
      return acc + parseFloat(current?.amt);
    } else {
      return acc;
    }
  }, 0);
  return sum;
};
export const sumOfPaymentRecordAmount = (paymentRecords) => {
  const sum = paymentRecords.reduce((acc, current) => {
    if (current?.amt && current?.amt !== "") {
      return acc + parseFloat(current.amt);
    } else {
      return acc;
    }
  }, 0);
  return sum;
};